import * as React from "react";
import { DecorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

export const CardComparisonBenefitsTitleEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  const [benefitsTitle] = React.useMemo(
    () => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />),
    []
  );

  return (
    <UitkSpacing
      padding={{
        extra_large: { inlinestart: "twelve" },
        large: { inlinestart: "twelve" },
        medium: { inline: "twelve" },
      }}
      margin={{
        extra_large: { inlinestart: "six" },
        large: { inlinestart: "six" },
        medium: { inline: "twelve" },
      }}
    >
      <UitkText size={400} weight="bold">
        <UitkSpacing padding={{ blockend: "six" }}>
          <div>{benefitsTitle}</div>
        </UitkSpacing>
      </UitkText>
    </UitkSpacing>
  );
};

export default CardComparisonBenefitsTitleEditorial;
